import { z } from 'zod';
import { subjectSchema } from './content.js';
import { GOALS_MAX, onboardingGoalSchema, onboardingOptionsSchema, } from './onboarding.js';
import { lessonReviewSchema } from './review.js';
/**
 * What the console and the viewer it frames say to each other — spec 013 §10.1.
 *
 * Both sides parse these, because nothing stops any origin posting anything: the type a
 * `MessageEvent` claims is only a guard once a schema has checked it.
 */
/**
 * Where the console asked the run to open — GEN-90. The console counts its clicks, so
 * asking for the same scene twice is a new message and opens it again.
 */
export const viewerJumpSchema = z.object({
    sceneId: z.string(),
    nonce: z.number(),
});
/** The palette the draft is read in — GEN-94. The console owns the control. */
export const viewerSchemeSchema = z.enum(['light', 'dark']);
/**
 * `play` runs the lesson as a learner meets it; `key` shows the marked answers — GEN-80.
 */
export const viewerModeSchema = z.enum(['play', 'key']);
/**
 * The preview's learner, as the console picks it: their goals and interests, and which
 * topics the console wants shown as not ready. Every other topic is ready.
 */
export const previewSampleSchema = z.object({
    goals: z.array(onboardingGoalSchema).max(GOALS_MAX),
    interests: z.array(subjectSchema),
    unready: z.array(subjectSchema),
});
export const viewerLessonMessageSchema = z.object({
    type: z.literal('lesson'),
    lesson: lessonReviewSchema,
    // Defaulted because the pane and the admin framing it can ship apart; the defaults are
    // what the pane is for and what it has always shown.
    mode: viewerModeSchema.default('play'),
    scheme: viewerSchemeSchema.default('light'),
    jump: viewerJumpSchema.optional(),
});
/** Onboarding as the console is editing it — ONB-19. */
export const viewerOnboardingSchema = onboardingOptionsSchema
    .pick({ flow: true, copy: true, suggestions: true })
    .extend({
    stepId: z.string().optional(),
    challenge: lessonReviewSchema.optional(),
    /** Counted by the console, so selecting the same step again restarts it. */
    nonce: z.number(),
    sample: previewSampleSchema,
});
export const viewerOnboardingMessageSchema = z.object({
    type: z.literal('onboarding'),
    scheme: viewerSchemeSchema.default('light'),
    onboarding: viewerOnboardingSchema,
});
/**
 * The viewer announcing it listens. An iframe's `load` fires before React inside it has
 * mounted a listener, and the frame announces again whenever it reloads.
 */
export const viewerReadySchema = z.object({ type: z.literal('viewer-ready') });
//# sourceMappingURL=viewer.js.map